import { INDRAApiService } from '@ibe.services/api.indra.service';
import { HttpClient } from '@angular/common/http';
import { MOCK_STATUS, MOCK_URL_AVAILABLE_PASSENGER_TYPE, URL_AVAILABLE_PASSENGER_TYPES, MOCK_URL_AVAILABLE_PASSENGER_TYPE_UK_MARKET, PAX_TYPE_YOUNG_ADULT, PAX_TYPE_YOUNG_ADULT_CODE, PAX_TYPE_ADULT_CODE } from '@ibe.config';
import * as i0 from "@angular/core";
import * as i1 from "./api.indra.service";
import * as i2 from "@angular/common/http";
var INDRAPassengerTypeService = /** @class */ (function () {
    function INDRAPassengerTypeService(api, http) {
        this.api = api;
        this.http = http;
    }
    INDRAPassengerTypeService.prototype.getAvailablePassengerTypes = function (params) {
        if (MOCK_STATUS.PASSENGER_TYPE) {
            return this.getMockData(params);
        }
        else {
            return this.api.INDRA_get(URL_AVAILABLE_PASSENGER_TYPES + "market=" + params.market + "&journeyList" + params.journeyList + "&tripType=" + params.tripType);
        }
    };
    INDRAPassengerTypeService.prototype.getMockPassengerTypes = function (params) {
        return this.getMockData(params);
    };
    INDRAPassengerTypeService.prototype.getMockData = function (params) {
        if (params.isUnitedKingdomMarket) {
            return this.http.get(MOCK_URL_AVAILABLE_PASSENGER_TYPE_UK_MARKET);
        }
        else {
            return this.http.get(MOCK_URL_AVAILABLE_PASSENGER_TYPE);
        }
    };
    // for calendar, if only young adult passenger type (YTH) else (ADT)
    INDRAPassengerTypeService.prototype.getPassengerCodeByCount = function (passengers) {
        var codeWithCount = 0;
        Object.values(passengers).forEach(function (count) {
            if (+count > 0)
                codeWithCount++;
        });
        return codeWithCount === 1 && passengers[PAX_TYPE_YOUNG_ADULT] > 0 ? PAX_TYPE_YOUNG_ADULT_CODE : PAX_TYPE_ADULT_CODE;
    };
    INDRAPassengerTypeService.ngInjectableDef = i0.defineInjectable({ factory: function INDRAPassengerTypeService_Factory() { return new INDRAPassengerTypeService(i0.inject(i1.INDRAApiService), i0.inject(i2.HttpClient)); }, token: INDRAPassengerTypeService, providedIn: "root" });
    return INDRAPassengerTypeService;
}());
export { INDRAPassengerTypeService };
